module.exports = ".card{\n    background-color: white;\n    -webkit-box-shadow:0 3px 5px -1px rgba(0,0,0,.2), 0 6px 10px 0 rgba(0,0,0,.14), 0 1px 18px 0 rgba(0,0,0,.12);\n            box-shadow:0 3px 5px -1px rgba(0,0,0,.2), 0 6px 10px 0 rgba(0,0,0,.14), 0 1px 18px 0 rgba(0,0,0,.12);\n    color:#fff;\n  \n  }\n  .card-body h1 {\n    margin-top: 10px;\n  }\n  .card-body{\n    padding: 1px;\n  }\n  "


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/cqm-ns/cqm-ns-defect/cqmns-project-cards/cqmns-project-cards.component.css
// module id = ./src/app/modules/cqm-ns/cqm-ns-defect/cqmns-project-cards/cqmns-project-cards.component.css
// module chunks = main